import { UserListDTO } from '../user/user-list.dto';
import { TradeRequestEventListDTO } from './trade-request-event-list.dto';

export class TradeRequestOfferListDTO {

    user: UserListDTO;

    event: TradeRequestEventListDTO;

}
